// extracted by mini-css-extract-plugin
module.exports = {"root":"DisclosureAgreement_root_2fzPL","row":"DisclosureAgreement_row_1T8ab"};